var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30005 7V9.1L7.70005 9.8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1001 11.2V8.40005C16.1001 8.01365 16.4137 7.70005 16.8001 7.70005H18.8L18.5634 7.14845C18.3429 6.63395 17.8368 6.30005 17.2768 6.30005H12.6001V16.1H14.7351C14.6763 15.8102 14.6875 15.4959 14.796 15.1718C14.9794 14.623 15.4505 14.189 16.0126 14.0532C17.169 13.7732 18.2001 14.6412 18.2001 15.75C18.2001 15.8697 18.1875 15.9866 18.1651 16.1H20.3001V11.2H16.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.45 17.5C17.4165 17.5 18.2 16.7165 18.2 15.75C18.2 14.7835 17.4165 14 16.45 14C15.4835 14 14.7 14.7835 14.7 15.75C14.7 16.7165 15.4835 17.5 16.45 17.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 17.5C6.2165 17.5 7 16.7165 7 15.75C7 14.7835 6.2165 14 5.25 14C4.2835 14 3.5 14.7835 3.5 15.75C3.5 16.7165 4.2835 17.5 5.25 17.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6001 15.3999H20.3001",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 15.3999H2.09995",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 3.5H2.09995C1.32645 3.5 0.699951 4.1265 0.699951 4.9V16.1H3.53495C3.47615 15.8102 3.48735 15.4959 3.59585 15.1718C3.77925 14.623 4.25035 14.189 4.81315 14.0532C5.96885 13.7732 6.99995 14.6412 6.99995 15.75C6.99995 15.8697 6.98735 15.9866 6.96495 16.1H12.6V4.9C12.6 4.1265 11.9735 3.5 11.2 3.5ZM6.29995 12.6C4.36725 12.6 2.79995 11.0327 2.79995 9.1C2.79995 7.1673 4.36725 5.6 6.29995 5.6C8.23265 5.6 9.79995 7.1673 9.79995 9.1C9.79995 11.0327 8.23265 12.6 6.29995 12.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.dab6bce3.svg";
export { ForwardRef as ReactComponent };